// extracted by mini-css-extract-plugin
module.exports = {"displayLogs":"styles_displayLogs__1hczd"};